/**
 * Returns a callback to initialize the slick behavior.
 * @param {Element} component
 * @return {Function} A callback function
 */
 const handleProductsInit = (component) => () => {
     const $stage = $('<div id="gallery-stage" data-gallery-stage>');
     const $items = $('<div id="gallery-items" data-gallery-items>');

     $(component).children().detach().appendTo($items);
     $items.children().clone(true, true).appendTo($stage);
     $(component).append($stage, $items).appendTo();

     $stage
        .slick({
            slidesToShow: 1,
            touchThreshold: 200,
            focusOnSelect: true,
            dots: false,
            arrows: true,
            prevArrow: '<button class="slick-prev slick-arrow button button--teaser-text-only slick-arrow"></Button>',
            nextArrow: '<button class="slick-next slick-arrow button button--teaser-text-only slick-arrow"></Button>',
            infinite: false,
            swipeToSlide: true,
            centerMode: true,
            centerPadding: 0,
            variableWidth: false,
            asNavFor: '#gallery-items',
        });

     $('#gallery-stage a').attr('data-fancybox', 'gallery');


     $items
        .on('click', 'a', (e) => {
            e.preventDefault();
        })
        .slick({
            touchThreshold: 200,
            focusOnSelect: true,
            dots: false,
            arrows: false,
            infinite: false,
            swipeToSlide: true,
            centerMode: true,
            centerPadding: 0,
            variableWidth: true,
            asNavFor: '#gallery-stage',
        });
 };

 export default handleProductsInit;



// WEBPACK FOOTER //
// ./src/scripts/components/gallery/handleProductsInit.js